/* eslint-disable */
export default {
  recentActivities: 'Recente activiteiten',
  text: 'Tekstbericht',
  fax: 'Fax',
  voicemail: 'Voicemail',
  call: 'Oproep',
} as const;

// @key: @#@"recentActivities"@#@ @source: @#@"Recent Activities"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"fax"@#@ @source: @#@"Fax"@#@
// @key: @#@"voicemail"@#@ @source: @#@"Voicemail"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
